import React from 'react'
import Title from 'components/Slides/Title'

export default Title({
  courseName: 'WordPress',
  courseImage: require('../images/cool-mat-design.jpg'),
  weekNumber: 'Week 2',
  projectTitle: 'cool mat',
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/01-intro.js